import React from "react"
import { useTranslation } from "react-i18next"
import BirthdayIcon from "@/assets/icons/farm/birthday-icon.tsx"
import DateIcon from "@/assets/icons/task/date-icon.tsx"
import { DrawerDatePicker } from "@/components/generic-date-picker/drawer-date-picker.tsx"
import OverflowMenuItem from "@/components/task-card/overflow-menu-item.tsx"
import { type AnimalDraft } from "@/features/farm"

interface AnimalDateSelectGroupProps {
  receivedAnimal: AnimalDraft
  handleBirthDateChange: (date: string) => void
  handleEntryDateChange: (date: string) => void
}

const AnimalDateSelectGroup: React.FC<AnimalDateSelectGroupProps> = ({
  receivedAnimal,
  handleBirthDateChange,
  handleEntryDateChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <OverflowMenuItem>
        <DrawerDatePicker
          isRequired={receivedAnimal.birth_date === ""}
          className={"h-10"}
          icon={<BirthdayIcon />}
          placeholder={t("birthDate")}
          value={receivedAnimal.birth_date}
          onChange={handleBirthDateChange}
          dateInterval={{
            after: new Date("1900-01-01"),
            before: new Date(),
          }}
        />
      </OverflowMenuItem>

      <OverflowMenuItem>
        <DrawerDatePicker
          isRequired={receivedAnimal.entry_date === ""}
          className={"h-10"}
          icon={<DateIcon fill={"#C5B6A9"} />}
          placeholder={t("exploitEntryDate")}
          value={receivedAnimal.entry_date}
          onChange={handleEntryDateChange}
          dateInterval={{
            after: new Date("1900-01-01"),
            before: new Date(),
          }}
        />
      </OverflowMenuItem>
    </>
  )
}

export default AnimalDateSelectGroup
